import React from 'react'
import styled from 'styled-components'
import { DisplayAlert } from './Video.components'

type Props = {
  isPlaying: boolean
  url: string
}

type Error = {
  state: boolean
  message: string
}

export default function MjpgPlayer({
  isPlaying,
  url
}: Props) {
  const ref: any = React.useRef(null)
  const [error, setError] = React.useState<Error>()

  const streamingUrl = React.useMemo(() => {
    if (isPlaying) {
      return url
    }
  }, [isPlaying])

  const imageOnLoad = () => {
    // const el: HTMLImageElement = ref?.current as HTMLImageElement
    // if (el) {
    //   el.src = `${url}&t=${new Date().getTime()}`
    // }
  }

  const imageOnError = () => {
    setError({ state: false, message: '出現無預期的錯誤'})
  }

  return (
    error ? (
      <DisplayAlert message={error.message} />
    ) : (
      <ImagePlayer
        ref={ref}
        onLoad={imageOnLoad}
        onError={imageOnError}
        src={streamingUrl}
      />
    )
  )
}

const ImagePlayer = styled.img`
  height: 100%;
  background: #000;
`
